export const MARKETING_LOADING = "MARKETING_LOADING";
export const MARKETING_RESET = "MARKETING_RESET";
export const GET_MARKETING = "GET_MARKETING";
export const GET_MARKETING_SUCCESS = "GET_MARKETING_SUCCESS";
export const GET_MARKETING_FAIL = "GET_MARKETING_FAIL";
export const DELETE_MARKETING = "DELETE_MARKETING"
export const DELETE_MARKETING_SUCCESS = "DELETE_MARKETING_SUCCESS"
export const DELETE_MARKETING_FAIL = "DELETE_MARKETING_FAIL"
export const UPDATE_MARKETING = "UPDATE_MARKETING"
export const UPDATE_MARKETING_SUCCESS = "UPDATE_MARKETING_SUCCESS"
export const UPDATE_MARKETING_FAIL = "UPDATE_MARKETING_FAIL"
export const ADD_NEW_MARKETING = "ADD_NEW_MARKETING"
export const ADD_MARKETING_SUCCESS = "ADD_MARKETING_SUCCESS"
export const ADD_MARKETING_FAIL = "ADD_MARKETING_FAIL"